<template>
  <header id="a-slider">
    <div class="slider-container">
      <div class="slider-scroll" data-cta>
        <u>Scroll to discover</u>
      </div>

      <div class="slider-active">
        <div class="slider-current">
          <div class="slider-heading"></div>
          <div class="slider-description"></div>
        </div>
        <div class="slider-next">
          <div class="slider-heading"></div>
          <div class="slider-description"></div>
        </div>
      </div>

      <div class="slider-adjacent">
        <div class="slider-current">
          <div class="slider-heading"></div>
        </div>
        <div class="slider-next">
          <div class="slider-heading"></div>
        </div>
      </div>

      <div class="slider-indicator" data-indicator>
        <svg class="indicator" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="outer" d="M48 95.5C74.2335 95.5 95.5 74.2335 95.5 48C95.5 21.7665 74.2335 0.5 48 0.5C21.7665 0.5 0.5 21.7665 0.5 48C0.5 74.2335 21.7665 95.5 48 95.5Z" fill="#DBDBDB" stroke="#383838" stroke-miterlimit="10" />
          <path class="inner" d="M47.5 67.5C58.5457 67.5 67.5 58.5457 67.5 47.5C67.5 36.4543 58.5457 27.5 47.5 27.5C36.4543 27.5 27.5 36.4543 27.5 47.5C27.5 58.5457 36.4543 67.5 47.5 67.5Z" fill="#E8E8E8" />
          <path class="arrow" d="M46.2 42.2L51.4 47.4L46.2 52.6" stroke="#383838" stroke-miterlimit="10" />
        </svg>
      </div>

      <div class="slider-cookie" @click="setCookie" v-if="showCookie">
        <p v-html="lang === 'it' ? 'Utilizzando il sito acconsenti alla nostra politica sui <a href=\'https://www.iubenda.com/privacy-policy/72080415/cookie-policy\' target=\'_blank\'>cookie</a>. Usiamo i cookie per migliorare la tua esperienza.' : 'By using this website, you agree to our use of <a href=\'https://www.iubenda.com/privacy-policy/98087786/cookie-policy\' target=\'_blank\'>cookie</a>. We use cookies to provide you with a great experience.'"></p>
        <span>✕</span>
      </div>
    </div>
  </header>
</template>

<script>
import { app, slider } from '@/utils/store';

import Slider from './slider';

export default {
  data() {
    return {
      lang: app.language,
      showCookie: true,
    };
  },
  mounted() {
    slider.app = new Slider();
    slider.app.init();
    if (localStorage.getItem('cookie:accepted')) this.showCookie = false;
  },
  methods: {
    setCookie() {
      localStorage.setItem('cookie:accepted', 'true');
      this.showCookie = false;
    },
  },
};
</script>
